export default __webpack_public_path__ + "static/media/fruit-1440w.e6c9d880.webp";